import type { Matrix4 } from 'three';

/** Exact affine composition of a root with a scaled local X-axis joint.
 * Equivalent to root * compose(position, quaternionX(angle), scale), without
 * constructing and multiplying two general projective matrices per limb. */
export function characterJoint(
  out: Matrix4,
  root: Matrix4,
  scale: readonly [number, number, number],
  x: number,
  y: number,
  z: number,
  angle: number,
): void {
  const r = root.elements,
    e = out.elements,
    [w, h, d] = scale;
  const sin = Math.sin(angle),
    cos = Math.cos(angle),
    px = x * w,
    py = y * h,
    pz = z * h;
  for (let row = 0; row < 3; row++) {
    e[row] = r[row] * w;
    e[row + 4] = (r[row + 4] * cos + r[row + 8] * sin) * h;
    e[row + 8] = (r[row + 8] * cos - r[row + 4] * sin) * d;
    e[row + 12] = r[row] * px + r[row + 4] * py + r[row + 8] * pz + r[row + 12];
  }
  e[3] = e[7] = e[11] = 0;
  e[15] = 1;
}
